/**
 * localStorage に保存された application_id を読み取り、対応するテーマを `:root` に書き込む。
 *
 * Utage-Web と同じ運用: 単一の真実の源は `localStorage[APPLICATION_ID_STORAGE_KEY]`。
 * URL の `?appId=<id>` は `persistNativeApplicationId()` 経由で localStorage に書き込む入り口専用で、
 * テーマ解決はここと `getCurrentApplicationId()` がどちらも localStorage を直接参照する。
 */
import { getCurrentApplicationId } from "~/lib/applicationId";
import { applyTheme } from "./applyTheme";
import { resolvePalette } from "./palettes";

export const resolveCurrentAppId = (): string => {
  return getCurrentApplicationId();
};

export const bootstrapTheme = (): void => {
  const palette = resolvePalette(resolveCurrentAppId());
  applyTheme(palette);
};
